import { render, staticRenderFns } from "./draft_news.vue?vue&type=template&id=6f1699ac&scoped=true"
import script from "./draft_news.vue?vue&type=script&lang=js"
export * from "./draft_news.vue?vue&type=script&lang=js"
import style0 from "./draft_news.vue?vue&type=style&index=0&id=6f1699ac&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f1699ac",
  null
  
)

export default component.exports